exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_wks-ext.js
// module id = 114
// module chunks = 0